import React from 'react';
import { Box, ButtonProps, Stack, Typography } from '@mui/material';
import { ButtonNaked, theme } from '@pagopa/mui-italia';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

type CardProps = {
  /**
   * Top icon
   */
  icon: React.ReactNode;
  /**
   * Main heading
   */
  title: string;
  /**
   * Body description
   */
  description: string;
  /**
   * Optional CTA
   */
  action?: ButtonProps & { label: string };
};

const styles = {
  flex: 1,
  borderRadius: '12px',
  position: 'relative',
  boxShadow: '0px 4px 32px 0px #0E0F131A'
};

export const Card: React.FC<CardProps> = ({
  icon,
  title,
  description,
  action
}) => {
  return (
    <Stack
      sx={styles}
      component="li"
      role="region"
      aria-label={title}
      maxWidth={{ xs: '100%', md: theme.spacing(35) }}
      gap={3}
      p={{ xs: 2, md: 3 }}
    >
      <Box display="flex" aria-hidden="true" role="img">
        {icon}
      </Box>

      <Stack
        gap={1}
        alignItems="flex-start"
        maxWidth={{ xs: '100%', md: theme.spacing(29) }}
      >
        {/* Heading */}
        <Typography variant={'h6'} component={'h3'} fontWeight="600">
          {title}
        </Typography>

        {/* Description */}
        <Typography variant="body2" component="p" color="textSecondary">
          {description}
        </Typography>

        {/* Optional CTA */}
        {action && (
          <ButtonNaked
            {...action}
            size="medium"
            sx={{ color: 'primary.main', mt: { xs: 0, md: 1 } }}
            endIcon={
              <span
                aria-hidden="true"
                style={{ display: 'flex', marginTop: '3px' }}
              >
                <ArrowForwardIcon fontSize="inherit" />
              </span>
            }
          >
            {action.label}
          </ButtonNaked>
        )}
      </Stack>
    </Stack>
  );
};
